var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-survey__popup-modal" }, [
    _c("div", { staticClass: "c-survey__popup-modal-content" }, [
      _c("h1", [_vm._v(_vm._s(_vm.heading))]),
      _vm._v(" "),
      _c("main", {
        staticClass: "c-survey__html",
        domProps: { innerHTML: _vm._s(_vm.message) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "c-survey__actionbutton-row" }, [
        _c(
          "a",
          {
            staticClass:
              "readmore readmore__linkBox readmore__linkBox--muted readmore__linkBox--arrow-left",
            attrs: { href: "#", target: "_self" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$emit("close")
              },
            },
          },
          [_c("p", [_vm._v("Cancel")]), _vm._v(" "), _c("span")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "readmore readmore__linkBox",
            attrs: { href: "#", target: "_self" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$emit("confirm")
              },
            },
          },
          [_c("p", [_vm._v("Confirm")]), _vm._v(" "), _c("span")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }